import { Box } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

const CircularLoader = () => {
  return (
    <div className="conf-registration-loader">
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
        height={700}
        bottom={150}
      >
        <CircularProgress size={70} />
      </Box>
    </div>
  );
};
export default CircularLoader;
